<template>
    <div>
        <el-table v-if="showTable"
                  size="mini"
                  :data="table"
                  :empty-text="emptyText"
                  stripe>
            <el-table-column
                    label="Parameter"
                    prop="parameter"
                    align="left"
                    min-width="165">
            </el-table-column>
            <el-table-column
                    v-if="includeSymbol"
                    label="Symbol"
                    prop="symbol"
                    align="center"
                    width="75">
            </el-table-column>
            <el-table-column
                    label="Value"
                    prop="value"
                    :align="alignValue"
                    min-width="75">
            </el-table-column>
            <el-table-column
                    v-if="includeUnits"
                    label="Units"
                    prop="units"
                    align="left"
                    width="60">
            </el-table-column>
        </el-table>
        <span v-else>
            <b style="color: darkorange;">WARNING: </b>
            <span style="color: var(--color)">Cannot calculate data.  Review model.</span>
        </span>
    </div>
</template>

<script>
  export default {
    name: "ModelerTableParams",
    props: {
      table: Array,
      emptyText: String,
      showSymbols: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      isTable() {
        return !!this.table && this.table.length !== 0;
      },
      showTable() {
        return this.isTable || this.emptyText;
      },
      includeSymbol() {
        return this.showSymbols && this.isTable && typeof this.table[0].symbol !== 'undefined';
      },
      includeUnits() {
        return (this.isTable && typeof this.table[0].units !== 'undefined') || this.emptyText;
      },
      alignValue() {
        return this.includeUnits ? 'right' : 'left';
      },
    },
  }
</script>

<style scoped>

</style>
